import axios from 'axios';
import { Bus, Stops } from './bus';

export default {
    ERROR_TIMEOUT: 1,
    ERROR_UNAUTHORIZED: 2,
    ERROR_NOTFOUND: 3,
    ERROR_UNKNOWNRESPONSE: 4,

    get(url, timeout = 60000) {
        return this.execute('get', url, timeout, null, 'application/json');
    },
    post(url, data, timeout = 60000) {
        return this.execute('post', url, timeout, data, 'application/json');
    },
    put(url, data, timeout = 60000) {
        return this.execute('put', url, timeout, data, 'application/json');
    },
    delete(url, timeout = 60000) {
        return this.execute('delete', url, timeout, null, 'application/json');
    },
    upload(url, data, onUploadProgress, timeout = 300000) {
        return this.execute('post', url, timeout, data, 'application/octet-stream', onUploadProgress);
    },
    execute(method, url, timeout, data, contentType, onUploadProgess) {
        return axios({
            method,
            url,
            timeout,
            onUploadProgess,
            headers: {
                'Content-type': contentType,
            },
            data,
        })
            .then(response => response.data)
            .catch(error => this.handle(error, url));
    },
    handle(error, url) {
        console.log(url);
        let errorCode = 0;
        if (error.response) {
            console.log(error.response);
            switch (error.response.status) {
                case 401:
                    errorCode = this.ERROR_UNAUTHORIZED;
                    Bus.$emit(Stops.UNAUTHORIZED);
                    break;
                case 404:
                    errorCode = this.ERROR_NOTFOUND;
                    Bus.$emit(Stops.TOAST, 'Ikke funnet');
                    break;
                default:
                    errorCode = this.ERROR_UNKNOWNRESPONSE;
                    Bus.$emit(Stops.TOAST, error.response.status);
            }
        } else if (error.request) {
            Bus.$emit(Stops.TOAST, 'Tidsavbrudd');
            errorCode = this.ERROR_TIMEOUT;
        } else {
            Bus.$emit(Stops.TOAST, error.message);
        }
        return { error, errorCode };
    },
};
